"use client"

import { useEffect } from "react"
import Cookies from "js-cookie"

/*
  Deletes all cookies not in the allowlist or allowed prefix on app load/reload.
  This should be imported and rendered at the top level (e.g., in layout.tsx) to ensure global effect.
*/

const allowedCookieNames = new Set([
  // Datadog
  "_dd_s",
  // Analytics - Segment
  "ajs_anonymous_id",
  "ajs_group_id",
  "ajs_user_id",
  // Marketing attribution shared from www.rhythms.ai to app.rhythms.ai
  "rhythms_attribution",
  // Workos
  "wos-session",
  // App state
  "isInTeams",
  // For e2e tests
  "bypass_workos_token",
  // For tenant switching
  "current-tenant-uuid",
  // For impersonation
  "impersonee-context",
])

const allowedCookieStartsWith = ["pylon-", "__next"]

export const shouldKeepCookie = (name: string) =>
  allowedCookieNames.has(name) ||
  allowedCookieStartsWith.some((prefix) => name.startsWith(prefix))

export function CookieCleanup() {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // Wait for all cookies to be set
      try {
        const allCookies = Cookies.get()
        for (const cookieName of Object.keys(allCookies)) {
          if (!shouldKeepCookie(cookieName)) {
            const currentDomain = window.location.hostname
            const rootDomain =
              "." + currentDomain.split(".").slice(-2).join(".")
            const wwwDomain = "www" + rootDomain
            const domains = [currentDomain, rootDomain, wwwDomain]
            const paths = ["/"]

            for (const domain of domains) {
              for (const path of paths) {
                Cookies.remove(cookieName, { domain, path })
              }
            }
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error during cookie cleanup:", error)
      }
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [])
  return null
}
